// Copyright (c) 2016 Deere & Company

import './failure-panel-container.scss';
import React, {PropTypes} from 'react';
import {getFieldClassNameForClaimFied, isValidationRequiredForClaimFied} from '../../services/claim-validation-helper';
import {
    getVsrMessage,
    hasVsrErrorForClaimField,
    isNotEmpty
} from '../../../shared/services/claim-shared-helper';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledInput from '../../../shared/components/claim-fields/labeled-input';
import LabeledInputWithBlur from '../../../shared/components/claim-fields/labeled-input-with-blur';
import LabeledKeyValueDropDown from '../../../shared/components/claim-fields/labeled-key-value-dropdown';
import LabeledTextArea from '../../../shared/components/claim-fields/labeled-text-area';
import LabeledTextAreaWithBlur from '../../../shared/components/claim-fields/labeled-text-area-with-blur';
import SpaClaim from '@deere/cps-it.warranty-model-factory/lib/claim-special-allowance';

const getBasisForSettlementLabel = status =>
    status.key === 'ZADT' ? 'BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS' : 'BASIS_FOR_SETTLEMENT';

function handleInputBlur(property, value) {

    this.actions.updateSpaClaimInputOnBlur(property, value);

}

function handleDropDownBlur(property, event) {

    this.actions.updateSpaClaimInputOnBlur(property, event.target.value);

}

function handleDownTimeChange(event) {

    this.actions.updateDownTimeDropDown(event.target.value, this.downTimeCollection);

}

function handleFailureModeChange(event) {

    this.actions.updateFailedModeDropDown(event.target.value, this.failureModes);

}

function handleBasisForSettlementChange(basisForSettlement) {

    this.actions.updateSpaClaimBasisForSettlement(basisForSettlement);

}

function handleOperatorsComplaintChange(complaint) {

    this.actions.updateSpaClaimOperatorsComplaint(complaint);

}

function handleOperatorCommentsChange(comments) {

    this.actions.updateSpaClaimOperatorComments(comments);

}

function handleComplaintCauseChange(cause) {

    this.actions.updateSpaClaimComplaintCause(cause);

}

function handleComplaintCorrectionChange(correction) {

    this.actions.updateSpaClaimComplaintCorrection(correction);

}

function handleDtacCaseChange(caseNumber) {

    this.actions.updateSpaClaimDtacCase(caseNumber);

}

function handleDtacSolutionChange(solution) {

    this.actions.updateSpaClaimDtacSolution(solution);

}

function handleFailureAreaChange(failureArea) {

    this.actions.updateSpaClaimFailedArea(failureArea);

}

function handlePartSerialNumberChange(partSerialNumber) {

    this.actions.updateSpaClaimPartSerialNumber(partSerialNumber);

}

function handleFailedModeCommentsChange(comments) {

    this.actions.updateSpaClaimFailedModeComments(comments);

}

function handleGoodsInstallationVatChange(event) {

    this.actions.updateGoodsInstallationVat(event.target.value, this.goodsInstallationVatOptions);

}

const FailurePanelContainer = props =>
    props.claim.showValidate ?
        null :
        <div className='failure-panel'>
            <div className='additional-failure-information'>
                <h3>
                    <FormattedMessage id='FAILURE_INFORMATION'/>
                </h3>
                <div className='failure-details'>
                    <LabeledKeyValueDropDown
                        className={getFieldClassNameForClaimFied('failed-mode', props.claim.specialAllowanceType, 'claim-required')}
                        errorMessage='FAILURE_MODE_IS_REQUIRED'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'failedMode', props.isEditable)}
                        isEditable={props.isEditable}
                        isValid={isValidationRequiredForClaimFied(props.claim.specialAllowanceType, props.formValidation.failureMode)}
                        label='FAILED_MODE'
                        list={props.failureModes}
                        onBlur={handleDropDownBlur.bind(props, 'failureMode')}
                        onChange={props::handleFailureModeChange}
                        selectedValue={props.claim.additionalFailureInfo.failureMode}
                        vsrMessage={getVsrMessage(props.claim.errors, 'failedMode', props.isEditable)}
                    />
                    <LabeledInputWithBlur
                        className={getFieldClassNameForClaimFied('failed-area', props.claim.specialAllowanceType, 'claim-required')}
                        errorMessage='FAILED_AREA_IS_REQUIRED'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'failedArea', props.isEditable)}
                        isEditable={props.isEditable}
                        isValid={isValidationRequiredForClaimFied(props.claim.specialAllowanceType, props.formValidation.failureArea)}
                        label='FAILED_AREA'
                        maxLength={40}
                        onBlur={handleInputBlur.bind(props, 'failureArea')}
                        onChange={props::handleFailureAreaChange}
                        value={props.claim.additionalFailureInfo.failureArea}
                        vsrMessage={getVsrMessage(props.claim.errors, 'failedArea', props.isEditable)}
                    />
                    <LabeledInput
                        className='part-serial-number'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'partSerialNumber', props.isEditable)}
                        isEditable={props.isEditable}
                        label='PART_SERIAL_NUMBER'
                        maxLength={18}
                        onChange={props::handlePartSerialNumberChange}
                        value={props.claim.additionalFailureInfo.failurePartSerialNumber}
                        vsrMessage={getVsrMessage(props.claim.errors, 'partSerialNumber', props.isEditable)}
                    />
                </div>
                {props.claim.additionalFailureInfo.failureMode.key === '17' &&
                    <LabeledInput
                        className='failed-mode-comments'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'failedModeComments', props.isEditable)}
                        isEditable={props.isEditable}
                        label='FAILED_MODE_COMMENTS'
                        maxLength={40}
                        onChange={props::handleFailedModeCommentsChange}
                        value={props.claim.additionalFailureInfo.failureModeComments}
                        vsrMessage={getVsrMessage(props.claim.errors, 'failedModeComments', props.isEditable)}
                    />
                }
                <LabeledKeyValueDropDown
                    className='downtime'
                    errorMessage='DOWNTIME_IS_REQUIRED'
                    highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'downtime', props.isEditable)}
                    isEditable={props.isEditable}
                    isValid={props.formValidation.downtime}
                    label='DOWNTIME'
                    list={props.downTimeCollection}
                    onBlur={handleDropDownBlur.bind(props, 'downtime')}
                    onChange={props::handleDownTimeChange}
                    selectedValue={props.claim.additionalFailureInfo.downtime}
                    vsrMessage={getVsrMessage(props.claim.errors, 'downtime', props.isEditable)}
                />
                <div className='dtac-details'>
                    <LabeledInput
                        className='dtac-case'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'dtacCase', props.isEditable)}
                        isEditable={props.isEditable}
                        label='DTAC_CASE'
                        maxLength={20}
                        onChange={props::handleDtacCaseChange}
                        value={props.claim.additionalFailureInfo.dtacCase}
                        vsrMessage={getVsrMessage(props.claim.errors, 'dtacCase', props.isEditable)}
                    />
                    <LabeledInput
                        className='dtac-solution'
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'dtacSolution', props.isEditable)}
                        isEditable={props.isEditable}
                        label='DTAC_SOLUTION'
                        maxLength={10}
                        onChange={props::handleDtacSolutionChange}
                        value={props.claim.additionalFailureInfo.dtacSolution}
                        vsrMessage={getVsrMessage(props.claim.errors, 'dtacSolution', props.isEditable)}
                    />
                    {props.claim.showGoodsInstallationVat &&
                        <LabeledKeyValueDropDown
                            className='goods-installation-vat'
                            errorMessage='GOODS_INSTALLATION_VAT_IS_REQUIRED'
                            highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'goodsInstallationVat', props.isEditable)}
                            isEditable={props.isEditable}
                            isValid={true}
                            label='GOODS_INSTALLATION_VAT'
                            list={props.goodsInstallationVatOptions}
                            onChange={props::handleGoodsInstallationVatChange}
                            selectedValue={props.claim.goodsInstallationVat}
                            vsrMessage={getVsrMessage(props.claim.errors, 'goodsInstallationVat', props.isEditable)}
                        />
                    }
                </div>
            </div>
            <div className='complaint-cause-correction'>
                <LabeledTextAreaWithBlur
                    className={getFieldClassNameForClaimFied('operators-complaint', props.claim.specialAllowanceType, 'claim-required')}
                    errorMessage='OPERATORS_COMPLAINT_IS_REQUIRED'
                    highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'operatorsComplaint', props.isEditable)}
                    isEditable={props.isEditable}
                    isValid={isValidationRequiredForClaimFied(props.claim.specialAllowanceType, props.formValidation.operatorsComplaint)}
                    label='OPERATORS_COMPLAINT'
                    onBlur={handleInputBlur.bind(props, 'operatorsComplaint')}
                    onChange={props::handleOperatorsComplaintChange}
                    value={props.claim.complaintCauseCommentsBasis.operatorsComplaint}
                    vsrMessage={getVsrMessage(props.claim.errors, 'operatorsComplaint', props.isEditable)}
                />
                <LabeledTextAreaWithBlur
                    className={getFieldClassNameForClaimFied('complaint-cause', props.claim.specialAllowanceType, 'claim-required')}
                    errorMessage='COMPLAINT_CAUSE_IS_REQUIRED'
                    highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'complaintCause', props.isEditable)}
                    isEditable={props.isEditable}
                    isValid={isValidationRequiredForClaimFied(props.claim.specialAllowanceType, props.formValidation.complaintCause)}
                    label='COMPLAINT_CAUSE'
                    onBlur={handleInputBlur.bind(props, 'complaintCause')}
                    onChange={props::handleComplaintCauseChange}
                    value={props.claim.complaintCauseCommentsBasis.causeOfComplaining}
                    vsrMessage={getVsrMessage(props.claim.errors, 'complaintCause', props.isEditable)}
                />
                <LabeledTextAreaWithBlur
                    className={getFieldClassNameForClaimFied('complaint-correction', props.claim.specialAllowanceType, 'claim-required')}
                    errorMessage='COMPLAINT_CORRECTION_IS_REQUIRED'
                    highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'complaintCorrection', props.isEditable)}
                    isEditable={props.isEditable}
                    isValid={isValidationRequiredForClaimFied(props.claim.specialAllowanceType, props.formValidation.complaintCorrection)}
                    label='COMPLAINT_CORRECTION'
                    onBlur={handleInputBlur.bind(props, 'complaintCorrection')}
                    onChange={props::handleComplaintCorrectionChange}
                    value={props.claim.complaintCauseCommentsBasis.howWasComplaintCorrected}
                    vsrMessage={getVsrMessage(props.claim.errors, 'complaintCorrection', props.isEditable)}
                />
                {isNotEmpty(props.claim.complaintCauseCommentsBasis.comments) &&
                    <LabeledTextArea
                        className='operator-comments'
                        disabled={true}
                        highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'operatorComments', props.isEditable)}
                        isEditable={props.isEditable}
                        label='COMMENTS'
                        onChange={props::handleOperatorCommentsChange}
                        value={props.claim.complaintCauseCommentsBasis.comments}
                        vsrMessage={getVsrMessage(props.claim.errors, 'operatorComments', props.isEditable)}
                    />
                }
                <LabeledTextAreaWithBlur
                    className='basis-for-settlement'
                    errorMessage='BASIS_FOR_SETTLEMENT_IS_REQUIRED'
                    highlightClass={hasVsrErrorForClaimField(props.claim.errors, 'basisForSettlement', props.isEditable)}
                    isEditable={props.isEditable || props.claim.claimStatus.key === 'ZADT'}
                    isValid={props.formValidation.basisForSettlement}
                    label={getBasisForSettlementLabel(props.claim.claimStatus)}
                    onBlur={handleInputBlur.bind(props, 'basisForSettlement')}
                    onChange={props::handleBasisForSettlementChange}
                    value={props.claim.complaintCauseCommentsBasis.basisForSettlement}
                    vsrMessage={getVsrMessage(props.claim.errors, 'basisForSettlement', props.isEditable)}
                />
            </div>
        </div>;

FailurePanelContainer.displayName = 'FailurePanelContainer';
FailurePanelContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    claim: PropTypes.instanceOf(SpaClaim).isRequired,
    downTimeCollection: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    failureModes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    formValidation: PropTypes.object.isRequired,
    goodsInstallationVatOptions: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    isEditable: PropTypes.bool.isRequired,
    isValidClaim: PropTypes.bool.isRequired
};

export default FailurePanelContainer;



// WEBPACK FOOTER //
// ./src/claim/spa/components/failure-panel/failure-panel-container.js